// extracted by mini-css-extract-plugin
module.exports = {"container":"Anchor_container__1G6TS","emptyMessage":"Anchor_emptyMessage__1GHcI"};